module.exports = __webpack_public_path__ + "af96fc59ced52445cac13afb1607cb69.MP3";